/**
 * Formats a byte count into a human-readable string.
 * Handles null, undefined, and zero values gracefully.
 */
export function formatBytes(bytes: number | null | undefined, locale = 'en'): string {
  if (!bytes || bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024));
  const index = Math.min(i, units.length - 1);
  return (
    new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
      bytes / Math.pow(1024, index)
    ) +
    ' ' +
    units[index]
  );
}
